import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { AppRoutes } from "@/routes";

export const useIsExternalPage = () => {
  const { pathname } = useLocation();

  const isExternalPage =
    pathname &&
    [
      AppRoutes.AUTH(),
      AppRoutes.EMAIL_LINK(),
      AppRoutes.PRIVACY(),
      AppRoutes.ROOT(),
      AppRoutes.SIGN_IN(),
      AppRoutes.SIGN_UP(),
      AppRoutes.TERMS(),
    ].includes(pathname);

  return useMemo(() => {
    return isExternalPage;
  }, [isExternalPage]);
};
